import { render, staticRenderFns } from "./DatabaseView.vue?vue&type=template&id=a4a9157e&"
import script from "./DatabaseView.vue?vue&type=script&lang=js&"
export * from "./DatabaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports